import React from 'react'

const Footer=(props)=> {
    return (
      <div className="footer">
        <pre className="last"><i class="fa-regular fa-copyright"></i>  Copyright | All Rights Reserved</pre><br />
        <pre>Mohammad Ziya</pre>
        
      </div>
    )
  }


export default Footer
